import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const imgSocial = {
  paddingRight: "10px",
  height: "20px",
  width: "20px",
  objectFit: "contain",
};
const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  paddingRigth: "5px",
  marginRigth: "5px",
  lineHeight: "0",
};

export default function Instagram(instagram) {
  return (
    <>
      <a href={`${instagram.instagram}`}
        style={PhoneLink}
      >
        <img style={imgSocial} src={`https://files.myclientisrich.com/${client}/insta.png`} alt="logo"></img>
      </a>
      <br />
    </>
  );
}
